import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full w-full bg-gray-100" }
const _hoisted_2 = { class: "info-line flex flex-row w-full bg-gray-300 text-dark-500 justify-start" }
const _hoisted_3 = { class: "plcae-content-center text-sm ml-2 box-border border" }
const _hoisted_4 = { class: "plcae-content-center text-sm ml-2 box-border border" }
const _hoisted_5 = { class: "plcae-content-center text-sm ml-2 box-border border" }
const _hoisted_6 = { class: "plcae-content-center text-sm ml-2 box-border border" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_keyboard = _resolveComponent("keyboard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_keyboard, { onLastkeyPressed: _ctx.onLastKey }, null, 8, ["onLastkeyPressed"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, " code: " + _toDisplayString(_ctx.lastKey.code), 1),
      _createElementVNode("div", _hoisted_4, " key: " + _toDisplayString(_ctx.lastKey.key), 1),
      _createElementVNode("div", _hoisted_5, " keyCode: " + _toDisplayString(_ctx.lastKey.keyCode), 1),
      _createElementVNode("div", _hoisted_6, " History: " + _toDisplayString(_ctx.his), 1)
    ])
  ]))
}